function getCookie(cname) {
  if (!process.browser) return;
  const cookie = document.cookie;
  let search = `${ cname }=`;

  if (cookie.length) {
    let startIndex = cookie.indexOf(cname),
        endIndex;

    if (startIndex !== -1) {
      startIndex += cname.length;
      endIndex = cookie.indexOf(';', startIndex);

      if (endIndex === -1) {
        endIndex = cookie.length;
      }

      return unescape(cookie.substring(startIndex + 1, endIndex));
    } else {
      return '';
    }
  } else {
    return '';
  }
}

function setCookie(cname, cvalue, et) {
  const d = new Date();
  let expireTime = '';

  if (et) {
    expireTime = et.toGMTString();
  } else {
    expireTime = 'session';
  }

  document.cookie = `${ cname }=${ cvalue }; path=/; expires=${ expireTime };`;
}

function removeCookie(cname) {
  document.cookie = `${ cname }=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export { getCookie, setCookie, removeCookie };

